const pluginMiddleware = (store) => next => action => {
    next(action);
    const state = Object.assign({}, store.getState());

    if(typeof state.rootReducer.plugins !== "undefined"){
        for (let plugin of state.rootReducer.plugins) {
            import(/* webpackIgnore: true */ plugin).then((module) => {
                module.default(store, state, action);
            });
        }
    }
};

export default pluginMiddleware;
